import { render, staticRenderFns } from "./NvChapterList.vue?vue&type=template&id=0a911b3c&scoped=true&"
import script from "./NvChapterList.vue?vue&type=script&lang=js&"
export * from "./NvChapterList.vue?vue&type=script&lang=js&"
import style0 from "./NvChapterList.vue?vue&type=style&index=0&id=0a911b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a911b3c",
  null
  
)

export default component.exports